import _ from 'lodash'
import { Map, List, fromJS, isImmutable } from 'immutable'
import { getParentIdInModal, LAYOUT_MODE } from '../../constants/toUnits'
import * as actionTypes from './actionTypes'
import { processWidgetSFMapping } from './processWidgetSFMapping'
import { getPageUID } from '../../lib/getValueByType'
import { parseURLParameters } from '../../lib/common'
import { getElementDataRoot } from '../../constants/getElementDataRoot'
import { SURVEY_EMAIL_TYPE, SURVEY_TYPE } from '../../constants/features'
import { processValueRules } from '../../lib/rules'
import { LIST_BASED_FIELDS } from '../../constants/LIST_BASED_FIELDS'
import { getMappingCount } from '../../constants/getMappingCount'
import { getState as getAppState } from '../../lib/processPortalRules'
import { defaultProfileMenu } from '../../components/Project/UI/Dialog/ManageMenu/defaultProfileMenu'
import FIELD_VALIDATION_CAPTIONS from '../../constants/FIELD_VALIDATION_CAPTIONS'
import PROJECT_CAPTIONS from '../../constants/PROJECT_CAPTIONS'

const ALL_PROJ_CAPTIONS = {
  ...FIELD_VALIDATION_CAPTIONS,
  ...PROJECT_CAPTIONS,
}

const RULE_KEEP_KEYS = [
  'width',
  'height',
  'typeOfModal',
  'positionOfModal',
  'hideIcon',
  'isHideTitle',
  'allowBtnClose',
  'btnCloseAction',
  'appearance',
  'autoDismiss',
  'autoDismissTimeout',
  'allowBtn1',
  'btn1Action',
  'allowBtn2',
  'btn2Action',
  'confAction',
  'cancelAction',
  'variant',
]

const ELEM_ACTION_KEYS = ['action', 'onOpen', 'onModalOpen', 'onModalClose']

const SMART_EVENTS_KEYS = ['onLogin', 'onBeforeLogOut', 'onLogOut', 'onSessionExpire', 'onWrongOTP']

// Ensure data.msgDlg.0 is a Map before writing nested keys under it
const normalizeMsgDlgData = (data) => {
  if (!Map.isMap(data)) {
    return Map({ msgDlg: Map({ '0': Map() }) })
  }
  let msgDlgVal = data.get('msgDlg')
  if (List.isList(msgDlgVal)) {
    const first = msgDlgVal.get(0)
    return data.set('msgDlg', Map({ '0': Map.isMap(first) ? first : Map() }))
  }
  if (!Map.isMap(msgDlgVal)) {
    return data.set('msgDlg', Map({ '0': Map() }))
  }
  if (!Map.isMap(msgDlgVal.get('0'))) {
    return data.setIn(['msgDlg', '0'], Map())
  }
  return data
}

const refreshValidationMessages = () => (dispatch, getState) => {
  let state = getState()
  const formFieldStatuses = state.get('formFieldStatuses', Map())
  const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List())
  const PageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === state.get('page'))
    ?.get?.('uid')

  const appState = getAppState(state)

  formFieldStatuses.map((val, parentID) => {
    if (parentID === PageUID) {
      if (Map.isMap(val)) {
        val.map((nextVal, eID) => {
          if (RepeatedStripsID.includes(eID)) {
            let size = getMappingCount(_.get(appState, [parentID, eID], {}))
            _.times(size, (index) => {
              nextVal.map((__, elID) => {
                if (Map.isMap(__) && __.get('status') === 'error') {
                  const component = state.getIn(['pages', state.get('page'), 'Props', 'elements', elID], Map())
                  const control = component.getIn(['props', 'control'], 'text')
                  let isListCheckbox = false
                  if (control == 'checkbox') {
                    isListCheckbox = component.getIn(['props', 'source'], 'single') !== 'single'
                  }
                  const getRepeatPath = (...args) => {
                    if (!args[0]) {
                      args[0] = 'state'
                    }
                    if (component.get('type') === 'FormField') {
                      let propName = []
                      if (control === 'currency' && args[0] != 'formFieldStatuses') {
                        propName = ['value']
                      }
                      if (
                        (LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox) &&
                        args[0] == 'state' &&
                        !args[1]
                      ) {
                        propName = ['ftListValue']
                      }
                      return [args[0], PageUID, eID, elID, ...propName, String(index)]
                    }
                    return [args[0], PageUID, eID, elID, String(index)]
                  }
                  dispatch(processValueRules(elID, component, getRepeatPath, index))
                }
              })
            })
          } else if (Map.isMap(nextVal) && nextVal.get('status') === 'error') {
            const component = state.getIn(['pages', state.get('page'), 'Props', 'elements', eID], Map())
            const control = component.getIn(['props', 'control'], 'text')
            let isListCheckbox = false
            if (control == 'checkbox') {
              isListCheckbox = component.getIn(['props', 'source'], 'single') !== 'single'
            }
            const getRepeatPath = (...args) => {
              if (!args[0]) {
                args[0] = 'state'
              }
              if (component.get('type') === 'FormField') {
                let propName = []
                if (control === 'currency' && args[0] != 'formFieldStatuses') {
                  propName = ['value']
                }
                if ((LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox) && args[0] == 'state' && !args[1]) {
                  propName = ['ftListValue']
                }
                return [args[0], PageUID, eID, ...propName]
              }
              return [args[0], PageUID, eID]
            }
            dispatch(processValueRules(eID, component, getRepeatPath, null))
          }
        })
      }
    } else {
      if (Map.isMap(val)) {
        val.map((nextVal, eID) => {
          const component = state.getIn(['project', 'Settings', 'elements', eID], Map())
          const control = component.getIn(['props', 'control'], 'text')
          let isListCheckbox = false
          if (control == 'checkbox') {
            isListCheckbox = component.getIn(['props', 'source'], 'single') !== 'single'
          }
          const parent = getParentIdInModal(state, component.get('parent'), true)
          const getRepeatPath = (...args) => {
            if (!args[0]) {
              args[0] = 'state'
            }
            if (component.get('type') === 'FormField') {
              let propName = []
              if (control === 'currency' && args[0] != 'formFieldStatuses') {
                propName = ['value']
              }
              if ((LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox) && args[0] == 'state' && !args[1]) {
                propName = ['ftListValue']
              }
              return [args[0], parent, eID, ...propName]
            }
            return [args[0], parent, eID]
          }
          dispatch(processValueRules(eID, component, getRepeatPath, null))
        })
      }
    }
  })
}

export const wbChangeLangProject = (FTLang, openPageID) => (dispatch, getState) => {
  let state = getState()
  if (!state.getIn(['project', 'Settings', 'translationSettings', 'enabled'])) {
    return false
  }
  const isWebSurvey = state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE
  let defaultLang = 'default'
  if (state.getIn(['project', 'Settings', 'translationSettings', 'translation'])) {
    state.getIn(['project', 'Settings', 'translationSettings', 'translation'], Map()).map((row, key) => {
      if (row.get('isDefault')) {
        defaultLang = key
      }
    })
  }
  let urlParams = parseURLParameters()

  if (!FTLang) {
    if (
      urlParams.FTLang &&
      state.getIn(['project', 'Settings', 'translationSettings', 'translation', urlParams.FTLang, 'active'])
    ) {
      FTLang = urlParams.FTLang
    } else {
      FTLang = defaultLang
    }
  }

  FTLang = String(FTLang).toLowerCase()

  if (!state.getIn(['project', 'Settings', 'translationSettings', 'translation', FTLang]) && FTLang !== 'default') {
    return false
  }

  if (!openPageID) {
    if (state.get('currentTranslation') == FTLang) {
      return false
    }
  }
  if (!state.get('currentTranslation') && !FTLang) {
    return false
  }

  let isNeedTranslate = true
  if (FTLang == 'default' && !state.get('sfPickListLang')) {
    isNeedTranslate = false
  }
  if (isNeedTranslate && state.get('sfPickListLang') != FTLang) {
    dispatch(processWidgetSFMapping('translate', null, null, null, true, FTLang))
  }
  // translationCache is the default language and not really cache that store another languages.
  // It is used in order to change back to English, without it the user's English texts will be deleted.
  let cache = state.get('translationCache', Map())
  let keepDefault = false
  if (!state.get('currentTranslation')) {
    keepDefault = true
  }

  if (!openPageID) {
    cache.map((value, key) => {
      const keyPath = String(key).split(':')
      state = state.setIn(keyPath, value)
    })
  }

  const setCache = (path, value) => {
    if (!cache.has(path.join(':'))) {
      cache = cache.set(path.join(':'), value)
    }
  }
  const getCache = (path, value) => {
    if (cache.has(path.join(':'))) {
      return cache.get(path.join(':'), value)
    }
  }

  if (FTLang === 'default') {
    cache.map((value, key) => {
      state = state.setIn(String(key).split(':'), value)
    })
    state = state.set('currentTranslation', FTLang)
    if (dispatch) {
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    }
    if (defaultLang) {
      FTLang = defaultLang
      FTLang = String(FTLang).toLowerCase()
    } else {
      return state
    }
  }

  let pages = state.getIn(['pages'], Map())
  state = state.set('currentTranslation', FTLang)

  const projID = state.getIn(['project', '_id'], null)
  const projRTL = state.getIn(['project', 'Settings', 'isRTL'], false)
  setCache(['project', 'Settings', 'isRTL'], projRTL)
  let orientation = state.getIn(
    ['project', 'Settings', 'translationSettings', 'translation', FTLang, 'orientation'],
    ''
  )
  if (orientation !== '') {
    let isRTL = orientation === 'rtl'
    state = state.setIn(['project', 'Settings', 'isRTL'], isRTL)
  }

  if (!state.getIn(['project', 'isPublic'], false) || state.getIn(['project', 'Settings', 'coBrowse', 'status'])) {
    if (!isImmutable(state.get('session'))) {
      state = state.set('session', Map())
    }
    let translation = state.getIn(['project', 'Settings', 'SmartV', 'translation', FTLang, 'captions'], Map())
    translation.map((str, key) => {
      if (str) {
        setCache(['session', 'captions', key], state.getIn(['session', 'captions', key]))
        state = state.setIn(['session', 'captions', key], str)
      }
    })
    let config = state.getIn(['project', 'Settings', 'SmartV', 'translation', FTLang, 'config'], Map())
    state.getIn(['session', 'authFields'], List()).map((field, fieldIndex) => {
      let str = getCache(['session', 'authFields', fieldIndex, 'label'])
      if (str !== null && str !== undefined) {
        state = state.setIn(['session', 'authFields', fieldIndex, 'label'], str)
      }
    })
    config.map((str, key) => {
      let fieldIndex = state.getIn(['session', 'authFields'], List()).findIndex((val) => val.get('uid') === key)
      setCache(
        ['session', 'authFields', fieldIndex, 'label'],
        state.getIn(['session', 'authFields', fieldIndex, 'label'])
      )
      if (str.getIn(['translation', FTLang]) && fieldIndex !== -1) {
        state = state.setIn(
          ['session', 'authFields', fieldIndex, 'label'],
          str.getIn(['translation', FTLang], getCache(['session', 'authFields', fieldIndex, 'label']))
        )
      }
    })
    let regConfig = state.getIn(['project', 'Settings', 'SmartV', 'translation', FTLang, 'regConfig'], Map())
    state.getIn(['session', 'registrationFields'], List()).map((field, fieldIndex) => {
      let str = getCache(['session', 'registrationFields', fieldIndex, 'label'])
      if (str !== null && str !== undefined) {
        state = state.setIn(['session', 'registrationFields', fieldIndex, 'label'], str)
      }
    })
    regConfig.map((str, key) => {
      let fieldIndex = state.getIn(['session', 'registrationFields'], List()).findIndex((val) => val.get('uid') === key)
      if (str.getIn(['translation', FTLang]) && fieldIndex !== -1) {
        setCache(
          ['session', 'registrationFields', fieldIndex, 'label'],
          state.getIn(['session', 'registrationFields', fieldIndex, 'label'])
        )
        state = state.setIn(['session', 'registrationFields', fieldIndex, 'label'], str.getIn(['translation', FTLang]))
      }
    })
    let profile = state.getIn(['project', 'Settings', 'SmartV', 'translation', FTLang, 'profile'], Map())
    profile.map((str, key) => {
      if (str.getIn(['translation', FTLang])) {
        setCache(['session', 'profileFields', key], state.getIn(['session', 'profileFields', key]))
        state = state.setIn(['session', 'profileFields', key], str.getIn(['translation', FTLang]))
      }
    })
  }

  let customCaption = state.getIn(['project', 'Settings', 'captions'], Map())
  let translation = state.getIn(['project', 'Settings', 'captions', 'translation', FTLang], Map())

  _.each(ALL_PROJ_CAPTIONS, (val, key) => {
    if (!translation.has(key) && !customCaption.has(key)) {
      translation = translation.set(key, val)
    }
  })

  // Clear survey captions if this is a web survey in order to avoid left over captions from previous language
  if (isWebSurvey) {
    state = state.deleteIn(['project', 'Settings', 'survey', 'captions'])
  }

  translation.map((val, key) => {
    if (!state.hasIn(['project', 'Settings', 'captions', 'translation', defaultLang, key])) {
      state = state.setIn(
        ['project', 'Settings', 'captions', 'translation', defaultLang, key],
        state.getIn(['project', 'Settings', 'captions', key], ALL_PROJ_CAPTIONS[key])
      )
    }
    setCache(['project', 'Settings', 'captions', key], state.getIn(['project', 'Settings', 'captions', key]))
    state = state.setIn(['project', 'Settings', 'captions', key], val)
    if (isWebSurvey) {
      state = state.setIn(['project', 'Settings', 'survey', 'captions', key], val)
    }
  })

  const processRuleTranslation = (rule) => {
    if (rule && rule.getIn(['translation', FTLang])) {
      rule = rule.setIn(['actions', 'msgDlg', '0'], rule.getIn(['translation', FTLang, 'msgDlg']))
      rule = rule.setIn(['actions', 'WorkFlow', '0'], rule.getIn(['translation', FTLang, 'WorkFlow']))
    }
    if (isImmutable(rule) && rule.get('modeType') === 'flow') {
      let nodes = rule.getIn(['actions', 'actionFlow', '0', 'list'], List())
      nodes = nodes.map((node) => {
        if (node.get('actionType') === 'WorkFlow') {
          if (node.getIn(['translation', FTLang])) {
            setCache([...rulePath, 'actions', 'actionFlow', '0', 'list', nodeIndex, 'data'], node.get('data'))
            let data = node.getIn(['translation', FTLang, 'data'], Map())
            if (!Map.isMap(data)) {
              data = Map()
            }
            data = normalizeMsgDlgData(data)
            const msgPath = ['WorkFlow', '0', 'modalMsg']
            return node.setIn(['data', ...msgPath], data.getIn(msgPath, node.getIn(['data', ...msgPath], '')))
          }
        }
        if (['msgDlg', 'msgDlgtoast', 'msgDlgconfirm'].includes(node.get('actionType'))) {
          if (node.getIn(['translation', FTLang])) {
            let data = node.getIn(['translation', FTLang, 'data'], Map())
            if (!Map.isMap(data)) {
              data = Map()
            }
            data = normalizeMsgDlgData(data)
            data = data.setIn(['msgDlg', '0', 'enabled'], data.getIn(['msgDlg', '0', 'enabled'], true))
            _.each(RULE_KEEP_KEYS, (key) => {
              data = data.setIn(['msgDlg', '0', key], node.getIn(['data', 'msgDlg', '0', key]))
            })
            return node.set('data', data)
          }
          return node
        } else {
          return node
        }
      })
      return rule.setIn(['actions', 'actionFlow', '0', 'list'], nodes)
    }
    return rule
  }

  const processActionKey = (path) => (rule, rulesKey) => {
    if (rule && rule.getIn(['translation', FTLang])) {
      setCache([...path, rulesKey, 'actions', 'msgDlg', '0'], rule.getIn(['actions', 'msgDlg', '0']))
      setCache([...path, rulesKey, 'actions', 'WorkFlow', '0'], rule.getIn(['actions', 'WorkFlow', '0']))
    }
    processRuleTranslation(rule)
    let nodes = rule.getIn(['actions', 'actionFlow', '0', 'list'], List())
    const rulePath = [...path, rulesKey]
    nodes = nodes.map((node, nodeIndex) => {
      if (node.get('actionType') === 'WorkFlow') {
        if (node.getIn(['translation', FTLang])) {
          let data = node.getIn(['translation', FTLang, 'data'], Map())
          if (!Map.isMap(data)) {
            data = Map()
          }
          data = normalizeMsgDlgData(data)
          const msgPath = ['WorkFlow', '0', 'modalMsg']
          return node.setIn(['data', ...msgPath], data.getIn(msgPath, node.getIn(['data', ...msgPath], '')))
        }
      }
      if (['msgDlg', 'msgDlgtoast', 'msgDlgconfirm'].includes(node.get('actionType'))) {
        if (node.getIn(['translation', FTLang])) {
          setCache([...rulePath, 'actions', 'actionFlow', '0', 'list', nodeIndex, 'data'], node.get('data'))
          let data = node.getIn(['translation', FTLang, 'data'], Map())
          if (!Map.isMap(data)) {
            data = Map()
          }
          data = normalizeMsgDlgData(data)
          data = data.setIn(['msgDlg', '0', 'enabled'], data.getIn(['msgDlg', '0', 'enabled'], true))
          _.each(RULE_KEEP_KEYS, (key) => {
            data = data.setIn(['msgDlg', '0', key], node.getIn(['data', 'msgDlg', '0', key]))
          })
          return node.set('data', data)
        }
        return node
      } else {
        return node
      }
    })
    state = state.setIn([...rulePath, 'actions', 'actionFlow', '0', 'list'], nodes)
  }

  state.getIn(['project', 'Settings', 'library'], Map()).map(processActionKey(['project', 'Settings', 'library']))

  const smart = state.getIn(['project', 'Settings', 'SmartV'], Map())
  if (smart.getIn(['useCustomProfile'])) {
    state
      .getIn(['project', 'Settings', 'SmartV', 'profActions'], List())
      .map(processActionKey(['project', 'Settings', 'SmartV', 'profActions']))
  }
  const cRegAct = state.getIn(['project', 'Settings', 'SmartV', 'customRegAction'], List())
  if (cRegAct.size > 0) {
    cRegAct.map(processActionKey(['project', 'Settings', 'SmartV', 'customRegAction']))
  }
  if (smart.getIn(['useCustomRegister'])) {
    state
      .getIn(['project', 'Settings', 'SmartV', 'regActions'], List())
      .map(processActionKey(['project', 'Settings', 'SmartV', 'regActions']))
  }

  _.each(SMART_EVENTS_KEYS, (evtKey) => {
    state
      .getIn(['project', 'Settings', 'ui', 'events', evtKey], List())
      .map(processActionKey(['project', 'Settings', 'ui', 'events', evtKey]))
  })

  const projMenuPath = ['project', 'Settings', 'Header', 'Menu']
  const processMenuItem =
    (path = []) =>
    (row, index) => {
      if (row && row.get('action', List())?.size > 0) {
        row.get('action', List()).map(processActionKey([...projMenuPath, index, 'action']))
      }
      row.get('children', List()).map(processMenuItem([...path, index, 'children']))
    }
  state.getIn(projMenuPath, List()).map(processMenuItem([]))

  state.getIn(['project', 'Settings', 'elements'], Map()).map((elem, elemID) => {
    const elemPath = ['project', 'Settings', 'elements', elemID]
    if (Map.isMap(elem)) {
      _.each(ELEM_ACTION_KEYS, (key) => {
        if (elem.getIn(['props', key])) {
          try {
            let rules = elem.getIn(['props', key], List())
            if (rules && isImmutable(rules)) {
              rules.map(processActionKey([...elemPath, 'props', key]))
            }
          } catch (err) {
            console.error(err)
          }
        }
      })
    }
  })

  const unloadPath = ['project', 'Settings', 'ui', 'unload']
  if (state.getIn([...unloadPath, 'active'])) {
    const translate = state.getIn([...unloadPath, 'translation', FTLang], Map())
    translate.map((value, key) => {
      setCache([...unloadPath, key], state.getIn([...unloadPath, key]))
      state = state.setIn([...unloadPath, key], value)
    })
    if (state.getIn([...unloadPath, 'onConfirm'], List()).size > 0) {
      state.getIn([...unloadPath, 'onConfirm'], List()).map(processActionKey([...unloadPath, 'onConfirm']))
    }
    if (state.getIn([...unloadPath, 'onCancel'], List()).size > 0) {
      state.getIn([...unloadPath, 'onCancel'], List()).map(processActionKey([...unloadPath, 'onCancel']))
    }
  }

  const storePath = ['project', 'Settings', 'store', 'public']
  state.getIn(storePath, Map()).map((item, id) => {
    if (item.get('type') === 'DOCGEN') {
      const transition = item.getIn(['translation', FTLang, 'lang'], Map())
      transition.map((value, key) => {
        setCache([...storePath, id, 'lang', key], state.getIn([...storePath, id, 'lang', key]))
        state = state.setIn([...storePath, id, 'lang', key], value)
      })
      item.get('previewActions', List()).map((action, index) => {
        if (action.get('action', List())?.size > 0) {
          action.get('action', List()).map(processActionKey([...storePath, id, 'previewActions', index, 'action']))
        }
      })
      item.get('interactiveActions', List()).map((action, index) => {
        if (action.get('action', List())?.size > 0) {
          action.get('action', List()).map(processActionKey([...storePath, id, 'interactiveActions', index, 'action']))
        }
      })
      item.get('editActions', List()).map((action, index) => {
        if (action.get('action', List())?.size > 0) {
          action.get('action', List()).map(processActionKey([...storePath, id, 'editActions', index, 'action']))
        }
      })
      if (item.get('onSubmit', List())?.size > 0) {
        item.get('onSubmit', List()).map(processActionKey([...storePath, id, 'onSubmit']))
      }
      if (item.get('onClose', List())?.size > 0) {
        item.get('onClose', List()).map(processActionKey([...storePath, id, 'onClose']))
      }
      if (item.getIn(['ui', 'onEditSubmit'], List())?.size > 0) {
        item.getIn(['ui', 'onEditSubmit'], List()).map(processActionKey([...storePath, id, 'ui', 'onEditSubmit']))
      }
      if (item.getIn(['ui', 'onEditClose'], List())?.size > 0) {
        item.getIn(['ui', 'onEditClose'], List()).map(processActionKey([...storePath, id, 'ui', 'onEditClose']))
      }
    }
  })

  state.getIn(['project', 'Settings', 'rules'], Map()).map((rules, rulesKey) => {
    if (rules) {
      rules.map((rule, index) => {
        if (rule && rule.getIn(['translation', FTLang])) {
          setCache(
            ['project', 'Settings', 'rules', rulesKey, index, 'actions', 'msgDlg', '0'],
            rule.getIn(['actions', 'msgDlg', '0'])
          )
        }
        state = state.setIn(['project', 'Settings', 'rules', rulesKey, index], processRuleTranslation(rule))
        if (isImmutable(rule) && rule.get('modeType') === 'flow') {
          let nodes = rule.getIn(['actions', 'actionFlow', '0', 'list'], List())
          const rulePath = ['project', 'Settings', 'rules', rulesKey, index]
          nodes = nodes.map((node, nodeIndex) => {
            if (['msgDlg', 'msgDlgtoast', 'msgDlgconfirm'].includes(node.get('actionType'))) {
              if (node.getIn(['translation', FTLang])) {
                setCache([...rulePath, 'actions', 'actionFlow', '0', 'list', nodeIndex, 'data'], node.get('data'))
                let data = node.getIn(['translation', FTLang, 'data'], Map())
                if (!Map.isMap(data)) {
                  data = Map()
                }
              data = normalizeMsgDlgData(data)
                data = data.setIn(['msgDlg', '0', 'enabled'], data.getIn(['msgDlg', '0', 'enabled'], true))
                _.each(RULE_KEEP_KEYS, (key) => {
                  data = data.setIn(['msgDlg', '0', key], node.getIn(['data', 'msgDlg', '0', key]))
                })
                return node.set('data', data)
              }
              return node
            } else {
              return node
            }
          })
          state = state.setIn([...rulePath, 'actions', 'actionFlow', '0', 'list'], nodes)
        }
      })
    }
  })

  if (state.getIn(['project', 'Pages'])) {
    state.getIn(['project', 'Pages'], List()).map((page, pageIndex) => {
      if (page) {
        if (page.getIn(['onceAction'])) {
          page.getIn(['onceAction']).map((rule, index) => {
            if (rule && rule.getIn(['translation', FTLang])) {
              setCache(
                ['project', 'Pages', pageIndex, 'onceAction', index, 'actions', 'msgDlg', '0'],
                rule.getIn(['actions', 'msgDlg', '0'])
              )
            }
            state = state.setIn(['project', 'Pages', pageIndex, 'onceAction', index], processRuleTranslation(rule))
          })
        }
        if (page.getIn(['action'])) {
          page.getIn(['action']).map((rule, index) => {
            if (rule && rule.getIn(['translation', FTLang])) {
              setCache(
                ['project', 'Pages', pageIndex, 'action', index, 'actions', 'msgDlg', '0'],
                rule.getIn(['actions', 'msgDlg', '0'])
              )
            }
            state = state.setIn(['project', 'Pages', pageIndex, 'action', index], processRuleTranslation(rule))
          })
        }
        // let pageRules = state.getIn(['project', 'Settings', 'rules', `${page.get('uid')}:${page.get('uid')}`])
        // if (pageRules) {
        //     pageRules.map((rule, index) => {
        //         if (rule && rule.getIn(['translation', FTLang])) {
        //             setCache(['project', 'Settings', 'rules', `${page.get('uid')}:${page.get('uid')}`, index, 'actions', 'msgDlg', '0'], rule.getIn(['actions', 'msgDlg', '0']))
        //         }
        //         state = state.setIn(['project', 'Settings', 'rules', `${page.get('uid')}:${page.get('uid')}`, index], processRuleTranslation(rule))
        //     })
        // }
      }
    })
  }

  if (state.getIn(['project', 'Settings', 'sfMapping'])) {
    state.getIn(['project', 'Settings', 'sfMapping']).map((row, uid) => {
      let translation = state.getIn(['project', 'Settings', 'sfMappingTranslation', FTLang, 'messages', uid])
      if (translation) {
        translation.map((val, key) => {
          setCache(
            ['project', 'Settings', 'sfMapping', uid, key],
            state.getIn(['project', 'Settings', 'sfMapping', uid, key])
          )
          state = state.setIn(['project', 'Settings', 'sfMapping', uid, key], val)
        })
      }
    })
  }
  
  const processTitleTranslation = (componentType, translationKey) => {
    if (state.getIn(['project', 'Settings', componentType, 'useTitle'])) {
      let val = state.getIn(['project', 'Settings', 'elements', translationKey, 'translation', FTLang], '')
      if (val) {
        setCache(['project', 'Settings', componentType, 'title'], state.getIn(['project', 'Settings', componentType, 'title']))
        state = state.setIn(['project', 'Settings', componentType, 'title'], val)
      }
    }
    return state
  }

  state = processTitleTranslation('Header', 'title')
  state = processTitleTranslation('Drawer', 'drawerTitle')
  
  const processMenuTranslations = (menuType) => {
    if (state.getIn(['project', 'Settings', menuType, 'enable'])) {
      let menu = state.getIn(['project', 'Settings', menuType, 'Menu'], List())
      menu.map((row, key) => {
        let val = state.getIn(['project', 'Settings', 'elements', 'Menu', row.get('id'), 'translation', FTLang], '')
        if (val) {
          setCache(
            ['project', 'Settings', menuType, 'Menu', key, 'Text'],
            state.getIn(['project', 'Settings', menuType, 'Menu', key, 'Text'])
          )
          state = state.setIn(['project', 'Settings', menuType, 'Menu', key, 'Text'], val)
        }
        if (row.get('children', List()).size > 0) {
          const processChildItem = (basePath) => (child, key) => {
            let val = state.getIn(['project', 'Settings', 'elements', 'Menu', child.get('id'), 'translation', FTLang], '')
            if (val) {
              setCache([...basePath, key, 'Text'], state.getIn([...basePath, key, 'Text']))
              state = state.setIn([...basePath, key, 'Text'], val)
            }
            if (child.get('children', List()).size > 0) {
              child.get('children', List()).map(processChildItem([...basePath, key, 'children']))
            }
          }
          row.get('children', List()).map(processChildItem(['project', 'Settings', menuType, 'Menu', key, 'children']))
        }
      })
    }
  }

  // Process Header Menu translations
  processMenuTranslations('Header')

  // Process Drawer Menu translations
  processMenuTranslations('Drawer')

  if (!state.getIn(['project', 'isPublic']) && state.getIn(['project', 'Settings', 'Header', 'enable'])) {
    let signinText = state.getIn(['project', 'Settings', 'elements', 'signinText', 'translation', FTLang], '')
    if (signinText) {
      let path = ['project', 'Settings', 'Header', 'signinText']
      setCache(path, state.getIn(path))
      state = state.setIn(path, signinText)
    }

    ///if not signed in
    let profileMenuPath = ['project', 'Settings', 'Header', 'ProfileMenu']
    let profileMenuElems = state.getIn(profileMenuPath, List())
    if (profileMenuElems.size === 0) {
      state = state.setIn(profileMenuPath, fromJS(defaultProfileMenu))
      profileMenuElems = state.getIn(profileMenuPath)
    }

    const signoutElemIdx = _.findIndex(profileMenuElems.toJS(), (elem) => elem.id === 'profileMenuSignOut')
    if (signoutElemIdx > -1) {
      let signoutText = state.getIn(['project', 'Settings', 'elements', 'signoutText', 'translation', FTLang], '')
      if (signoutText) {
        let path = ['project', 'Settings', 'Header', 'ProfileMenu', signoutElemIdx, 'Text']
        setCache(path, state.getIn(path))
        state = state.setIn(path, signoutText)
      }
    }

    const profileElemIdx = _.findIndex(profileMenuElems.toJS(), (elem) => elem.id === 'profileMenuProfile')
    if (profileElemIdx > -1) {
      let profileText = state.getIn(['project', 'Settings', 'elements', 'profileText', 'translation', FTLang], '')
      if (profileText) {
        let path = ['project', 'Settings', 'Header', 'ProfileMenu', profileElemIdx, 'Text']
        console.log('path', path)
        setCache(path, state.getIn(path))
        state = state.setIn(path, profileText)
      }
    }
  }

  const processElem = (pageID, pageUID) => (elem, elemUID) => {
    const elemRoot = getElementDataRoot(pageID)
    if (pageID === 'project') {
      if (['Header', 'Drawer'].includes(elem.get('type'))) {
        pageUID = elem.get('type')
      }
    }
    let elemKeys = ''
    let type = elem.get('type')
    if (type === 'FormField') {
      type = elem.getIn(['props', 'control'])
    }

    let translated = elem.getIn(['props', 'translation', FTLang], Map())

    if (translated.get('rules')) {
      let elemRules = state.getIn(['project', 'Settings', 'rules', `${pageUID}:${elemUID}`], List())
      elemRules.map((rule, ruleIndex) => {
        if (rule && rule.get('uid') && translated.getIn(['rules', rule.get('uid')])) {
          translated.getIn(['rules', rule.get('uid')]).map((val, key) => {
            setCache(
              ['project', 'Settings', 'rules', `${pageUID}:${elemUID}`, ruleIndex, 'actions', key, '0'],
              rule.getIn(['actions', key, '0'])
            )
            rule = rule.setIn(['actions', key, '0'], val)
          })
          state = state.setIn(['project', 'Settings', 'rules', `${pageUID}:${elemUID}`, ruleIndex], rule)
        }
      })
    }
    const translateAction = (rule, index) => {
      if (isImmutable(rule) && rule.get('modeType') === 'flow') {
        let nodes = rule.getIn(['actions', 'actionFlow', '0', 'list'], List())
        const rulePath = [...elemRoot, 'elements', elemUID, 'props', 'action', index]
        nodes = nodes.map((node, nodeIndex) => {
          if (node.get('actionType') === 'WorkFlow') {
            if (node.getIn(['translation', FTLang])) {
              setCache([...rulePath, 'actions', 'actionFlow', '0', 'list', nodeIndex, 'data'], node.get('data'))
              let data = node.getIn(['translation', FTLang, 'data'], Map())
              if (!Map.isMap(data)) {
                data = Map()
              }
              const msgPath = ['WorkFlow', '0', 'modalMsg']
              return node.setIn(['data', ...msgPath], data.getIn(msgPath, node.getIn(['data', ...msgPath], '')))
            }
          }
          if (['msgDlg', 'msgDlgtoast', 'msgDlgconfirm'].includes(node.get('actionType'))) {
            if (node.getIn(['translation', FTLang])) {
              setCache([...rulePath, 'actions', 'actionFlow', '0', 'list', nodeIndex, 'data'], node.get('data'))
              let data = node.getIn(['translation', FTLang, 'data'], Map())
              if (!Map.isMap(data)) {
                data = Map()
              }
              data = normalizeMsgDlgData(data)
              data = data
                .setIn(['msgDlg', '0', 'enabled'], data.getIn(['msgDlg', '0', 'enabled'], true))
                .setIn(['msgDlg', '0', 'variant'], node.getIn(['data', 'msgDlg', '0', 'variant']))
              _.each(RULE_KEEP_KEYS, (key) => {
                data = data.setIn(['msgDlg', '0', key], node.getIn(['data', 'msgDlg', '0', key]))
              })
              return node.set('data', data)
            }
            return node
          } else {
            return node
          }
        })
        state = state.setIn([...rulePath, 'actions', 'actionFlow', '0', 'list'], nodes)
      }
    }
    if (elem.getIn(['props', 'action'], List())?.size > 0) {
      elem.getIn(['props', 'action'], List()).map(translateAction)
    }
    if (translated.get('actions') && elem.getIn(['props', 'action'], List())?.size > 0) {
      elem.getIn(['props', 'action'], List()).map(function (rule, index) {
        if (rule && rule.get('uid') && translated.getIn(['actions', rule.get('uid')])) {
          translated.getIn(['actions', rule.get('uid')], Map()).map((val, key) => {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'action', index, 'actions', key, '0'],
              rule.getIn(['actions', key, '0'])
            )
            rule = rule.setIn(['actions', key, '0'], val)
          })
          state = state.setIn([...elemRoot, 'elements', elemUID, 'props', 'action', index], rule)
        }
      })
    }

    if (isWebSurvey) {
      let translated = elem.getIn(['props', 'translation', FTLang], Map())
      let elements = state.getIn(['pages', state.get('page'), 'Props', 'elements'], Map())
      if (translated.get('questionDescription') || translated.get('questionText')) {
        elements.map((elem, surveyID) => {
          if (elem && elem.get('type') == 'PageConditionalForm') {
            let tabs = elem.getIn(['props', 'lg', 'tabs'])
            if (tabs) {
              tabs.map((tab, tabIndex) => {
                if (tab.getIn(['info', elemUID])) {
                  if (translated.get('questionDescription')) {
                    setCache(
                      [...elemRoot, 'elements', elemUID, 'props', 'captions', 'questionDescription'],
                      tab.getIn(['info', elemUID, 'description'])
                    )
                    tab = tab.setIn(['info', elemUID, 'description'], translated.get('questionDescription'))
                  }
                  if (translated.get('questionText')) {
                    setCache(
                      [...elemRoot, 'elements', elemUID, 'props', 'captions', 'questionDescription'],
                      tab.getIn(['info', elemUID, 'title'])
                    )
                    tab = tab.setIn(['info', elemUID, 'title'], translated.get('questionText'))
                  }
                  state = state.setIn(
                    ['pages', state.get('page'), 'Props', 'elements', surveyID, 'props', 'lg', 'tabs', tabIndex],
                    tab
                  )
                }
              })
            }
          }
        })
      }
    }
    const elemPath = ['pages', pageID, 'Props', 'elements', elemUID]
    _.each(ELEM_ACTION_KEYS, (key) => {
      if (elem.getIn(['props', key]) && key !== 'action') {
        elem.getIn(['props', key], List()).map(processActionKey([...elemPath, 'props', key]))
      }
    })
    switch (type) {
      case 'SmartVOtpForm':
      case 'SmartVLoginForm': {
        let translated = elem.getIn(['props', 'translation', FTLang], Map())
        translated.map((toVal, key) => {
          if (toVal) {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
            )
            state = state.setIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key], toVal)
          }
        })
        break
      }
      case 'ECommerceCategories':
      case 'TextCounter':
      case 'InteractiveDocument':
      case 'Stripe':
      case 'Svg':
      case 'Badge':
      case 'phone':
      case 'lookup':
      case 'fileupload':
      case 'switch':
      case 'slider':
      case 'datetime':
      case 'daterange':
      case 'time':
      case 'text':
      case 'textarea':
      case 'richtextarea':
      case 'email':
      case 'currency':
      case 'number':
      case 'url':
      case 'date':
      case 'signature':
      case 'Search':
      case 'PageSearch':
      case 'Modal':
      case 'DrawerEl':
      case 'Button':
      case 'Link':
      case 'BarcodeReader':
      case 'YesNo':
      case 'StarRating':
      case 'Rating':
      case 'Capture':
      case 'Range':
      case 'CircleSlider':
      case 'Typography':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())
          translated.map((toVal, key) => {
            let useKey = String(key).includes('##') ? key.split('##') : [key]
            let defVal = elem.getIn(['props', 'lg', ...useKey])
            if (toVal) {
              if (
                defVal &&
                !state.hasIn([...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, key])
              ) {
                state = state.setIn(
                  [...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, key],
                  defVal
                )
              }
              _.each(LAYOUT_MODE, function (layoutMode) {
                if (elem.getIn(['props', layoutMode]) || layoutMode == 'lg') {
                  const path = [...elemRoot, 'elements', elemUID, 'props', layoutMode, ...useKey]
                  const value = state.getIn(path)
                  setCache(path, value)
                  state = state.setIn(path, toVal)
                }
              })

              if (key === 'captions##All') {
                let path = [...elemRoot, 'elements', elemUID, 'props', ...useKey]
                setCache(path, state.getIn(path, 'All'))
                state = state.setIn(path, toVal)
              }
              // check translation for items outside of Layout modes (currently only suffix, prefix and value rule message)
              defVal = elem.getIn(['props', ...useKey])

              // check translation for items that have a text property (suffix, prefix)
              if (isImmutable(defVal) && defVal.get('text')) {
                let translationPath = [...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, ...useKey]
                if (!state.hasIn(translationPath)) {
                  state = state.setIn(translationPath, defVal.get('text'))
                }

                let path = [...elemRoot, 'elements', elemUID, 'props', ...useKey]
                setCache(path, state.getIn(path))
                state = state.setIn([...path, 'text'], toVal)
              }

              // check translation for value rule message
              if (defVal && !isImmutable(defVal)) {
                const translationPath = [...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, key]
                const propertyPath = [...elemRoot, 'elements', elemUID, 'props', ...useKey]

                if (!state.hasIn(translationPath)) {
                  state = state.setIn(translationPath, defVal)
                }

                setCache(propertyPath, state.getIn(propertyPath))
                state = state.setIn(propertyPath, toVal)
              }
            }
          })

          let langs = {}
          if (FTLang != 'default') {
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })
          }
          _.each(langs.captions, (val, key) => {
            const path = [...elemRoot, 'elements', elemUID, 'props', 'captions', key]
            setCache(path, state.getIn(path))
            state = state.setIn(path, val)
          })
          _.each(langs.valueRule, (val, key) => {
            state = state.setIn(
              [...elemRoot, 'elements', elemUID, 'props', 'valueRule', ...String(key).split('##')],
              val
            )
          })
          if (
            state.getIn(['project', 'ProjectType']) === SURVEY_TYPE ||
            (state.getIn(['project', 'ProjectType']) === SURVEY_EMAIL_TYPE && type === 'Typography')
          ) {
            _.each(LAYOUT_MODE, (layoutMode) => {
              state = state.deleteIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, 'originText'])
            })
          }
        }
        break
      case 'ExternalLookup':
      case 'AddressFinder': {
        let translated = elem.getIn(['props', 'translation', FTLang], Map())
        let langs = {}
        let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
        if (FTLang != 'default') {
          translated.map((val, key) => {
            let path = String(key).replace('##', '.')
            langs = _.set(langs, path, val)
          })
        } else {
          langs = defLangs
        }

        let elemJS = elem.toJS()
        _.each(langs, (values, prop) => {
          if (prop === 'captions') {
            _.each(values, (val, key) => {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
              )
              elemJS = _.set(elemJS, ['props', 'captions', key], val)
            })
          } else {
            _.each(LAYOUT_MODE, function (layoutMode) {
              if (_.get(elemJS, ['props', layoutMode])) {
                elemJS = _.set(elemJS, ['props', layoutMode, prop], values)
              }
            })
          }
        })

        state = state.setIn([...elemRoot, 'elements', elemUID], fromJS(elemJS))
        break
      }
      case 'PowerTable':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())
          let langs = {}
          let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
          if (FTLang != 'default') {
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })
          } else {
            langs = defLangs
          }
          if (langs?.columns && isImmutable(langs.columns)) {
            langs.columns = langs.columns.toJS()
          }
          let elemJS = elem.toJS()
          const recursiveProcessCols = function (cols) {
            _.map(cols, (col) => {
              if (_.get(langs, ['columns', col.id])) {
                if (_.get(col, ['meta', 'role']) == 'text') {
                  if (_.get(defLangs, ['columns', col.id]) === undefined) {
                    _.set(defLangs, ['columns', col.id], _.get(col, ['meta', 'btnText']))
                  }
                  _.set(col, ['meta', 'btnText'], _.get(langs, ['columns', col.id]))
                } else {
                  if (_.get(defLangs, ['columns', col.id]) === undefined) {
                    _.set(defLangs, ['columns', col.id], col.Header)
                  }
                  col.Header = _.get(langs, ['columns', col.id])
                }
              }
              if (_.get(col, ['columns'], [])) {
                recursiveProcessCols(_.get(col, ['columns'], []))
              }
              if (_.get(col, ['meta', 'subCtrl', 'enable'])) {
                _.each(langs.captions, (val, key) => {
                  _.set(col, ['meta', 'subCtrl', 'Props', 'captions', key], val)
                })
                _.each(langs.messages, (val, key) => {
                  _.set(col, ['meta', 'subCtrl', 'Props', 'messages', key], val)
                })
                recursiveProcessCols(_.get(col, ['meta', 'subCtrl', 'Props', 'columns'], []))
              }
            })
          }
          _.each(langs.captions, (val, key) => {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
            )
            elemJS = _.set(elemJS, ['props', 'captions', key], val)
          })
          _.each(langs.messages, (val, key) => {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'messages', key],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'messages', key])
            )
            elemJS = _.set(elemJS, ['props', 'messages', key], val)
          })
          _.each(langs.pagination, (val, key) => {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'pagination', key],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'pagination', key])
            )
            elemJS = _.set(elemJS, ['props', 'pagination', key], val)
          })
          elemJS = _.set(elemJS, ['props', 'translation', defaultLang], defLangs)

          recursiveProcessCols(_.get(elemJS, ['props', 'columns'], []))

          state = state.setIn([...elemRoot, 'elements', elemUID], fromJS(elemJS))
        }
        break
      case 'Form':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())
          let langs = {}
          let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
          if (FTLang != 'default') {
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })
          }

          _.each(langs, function (val, key) {
            if (key == 'errorMsg' || key == 'successMsg') {
              _.each(val, function (val2, key2) {
                setCache(
                  [...elemRoot, 'elements', elemUID, 'props', key, key2],
                  state.getIn([...elemRoot, 'elements', elemUID, 'props', key, key2])
                )
                elem = elem.setIn(['props', key, key2], val2)
              })
            } else if (key == 'title' || key == 'header') {
              _.each(LAYOUT_MODE, function (layoutMode) {
                if (elem.getIn(['props', layoutMode]) || layoutMode == 'lg') {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', layoutMode, key],
                    state.getIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, key])
                  )
                  elem = elem.setIn(['props', layoutMode, key], val)
                }
              })
            } else {
              elem = elem.setIn(['props', 'lang', key], val)
            }
          })

          elem = elem.setIn(['props', 'translation', defaultLang], fromJS(defLangs))
          state = state.setIn([...elemRoot, 'elements', elemUID], elem)
        }
        break

      case 'Breadcrumb':
      case 'ItemList':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())
          let langs = {}
          let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
          if (FTLang != 'default') {
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })
          }

          let elemJS = elem.toJS()
          _.each(LAYOUT_MODE, function (layoutMode) {
            if (_.get(elemJS, ['props', layoutMode]) || layoutMode == 'lg') {
              _.map(_.get(elemJS, ['props', layoutMode, 'menu'], []), (item, index) => {
                if (_.get(langs, ['menu', item.uid])) {
                  setCache([...elemRoot, 'elements', elemUID, 'props', layoutMode, 'menu', index, 'text'], item.text)
                  item.text = _.get(langs, ['menu', item.uid])
                }
                if (item.child && item.child.length) {
                  _.each(item.child, function (child, childIndex) {
                    if (_.get(langs, ['menu', child.uid])) {
                      setCache(
                        [
                          ...elemRoot,
                          'elements',
                          elemUID,
                          'props',
                          layoutMode,
                          'menu',
                          index,
                          child,
                          childIndex,
                          'text',
                        ],
                        item.text
                      )
                      child.text = _.get(langs, ['menu', child.uid])
                    }
                  })
                }
              })
            }
          })

          elem = elem.setIn(['props', 'translation', defaultLang], fromJS(defLangs))
          state = state.setIn([...elemRoot, 'elements', elemUID], fromJS(elemJS))
        }
        break

      case 'FileViewer':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())

          translated.map((val, key) => {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'messages', key],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'messages', key])
            )
            elem = elem.setIn(['props', 'messages', key], val)
          })

          state = state.setIn([...elemRoot, 'elements', elemUID], elem)
        }
        break

      case 'Matrix': {
        let translated = elem.getIn(['props', 'translation', FTLang], Map())
        let langs = {}
        let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
        if (FTLang != 'default') {
          translated.map((val, key) => {
            let path = String(key).replace('##', '.')
            langs = _.set(langs, path, val)
          })
        }
        elem = elem.toJS()
        _.each(_.get(elem, ['props', 'items'], []), (item, index) => {
          if (_.get(langs, ['items', item.uid])) {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'items', index, 'label'],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'items', index, 'label'])
            )
            item.label = _.get(langs, ['items', item.uid])
          }
        })
        _.each(_.get(elem, ['props', 'questions'], []), (item, index) => {
          if (_.get(langs, ['questions', item.uid])) {
            setCache(
              [...elemRoot, 'elements', elemUID, 'props', 'questions', index, 'label'],
              state.getIn([...elemRoot, 'elements', elemUID, 'props', 'questions', index, 'label'])
            )
            item.label = _.get(langs, ['questions', item.uid])
          }
        })

        _.each(langs, (toVal, key) => {
          if (!['items', 'questions'].includes(key)) {
            if (toVal) {
              _.each(LAYOUT_MODE, function (layoutMode) {
                if (_.get(elem, ['props', layoutMode]) || layoutMode == 'lg') {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', layoutMode, key],
                    state.getIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, key])
                  )
                  _.set(elem, ['props', layoutMode, key], toVal)
                }
              })
            }
          }
        })

        state = state.setIn([...elemRoot, 'elements', elemUID], fromJS(elem))
        break
      }
      case 'checkbox':
      case 'radio':
      case 'multiSelect':
      case 'select':
      case 'CES':
      case 'SurveyList':
      case 'Ranking':
      case 'buttongroup': {
        if (elem.getIn(['props', 'lg', 'isDistinct']) || elem.getIn(['props', 'lg', 'isRandomize'])) {
          state = state.deleteIn(['metaInfo', pageUID, elemUID, 'processed'])
          // .deleteIn(['meta', pageUID, elemUID])
        }
        let translated = elem.getIn(['props', 'translation', FTLang], Map())
        let langs = {}
        let defLangs = elem.getIn(['props', 'translation', defaultLang], Map()).toJS()
        if (FTLang != 'default') {
          translated.map((val, key) => {
            let path = String(key).replace('##', '.')
            langs = _.set(langs, path, val)
          })
        }
        elem = elem.toJS()
        if (_.get(elem, ['props', 'source'], 'static') == 'static') {
          _.each(_.get(elem, ['props', 'items'], []), (item, index) => {
            if (_.get(langs, ['items', item.uid])) {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'items', index, 'label'],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'items', index, 'label'])
              )
              item.label = _.get(langs, ['items', item.uid])
            }
          })
        }

        _.each(langs, (toVal, key) => {
          if (key != 'items' && key !== 'valueRule') {
            if (toVal) {
              _.each(LAYOUT_MODE, function (layoutMode) {
                if (_.get(elem, ['props', layoutMode]) || layoutMode == 'lg') {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', layoutMode, key],
                    state.getIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, key])
                  )
                  _.set(elem, ['props', layoutMode, key], toVal)
                }
              })
            }
          }
        })

        state = state.setIn([...elemRoot, 'elements', elemUID], fromJS(elem))
        _.each(langs.captions, (val, key) => {
          setCache(
            [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
            state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
          )
          state = state.setIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key], val)
        })
        _.each(langs.valueRule, (val, key) => {
          setCache(
            [...elemRoot, 'elements', elemUID, 'props', 'valueRule', ...String(key).split('##')],
            state.getIn([...elemRoot, 'elements', elemUID, 'props', 'valueRule', ...String(key).split('##')])
          )
          state = state.setIn([...elemRoot, 'elements', elemUID, 'props', 'valueRule', ...String(key).split('##')], val)
        })
        break
      }
      // case 'lookup':
      //     result.push({
      //         key: [],
      //         label: elemLabel + '.Captions',
      //         type: 'sublevel',
      //         item: {
      //             element: 'lookup',
      //             pathToElement: [...item.pathToElement, elemUID],
      //             pathToProp: ['captions']
      //         }
      //     })
      //     elemPath = [elemUID, 'props']
      //     elemKeys = {
      //         'userTip': 'User Tip',
      //         placeholder: 'Placeholder',
      //         label: 'Label'
      //     };
      //     break;
      case 'PageConditionalForm': {
        if (isWebSurvey && type == 'PageConditionalForm') {
          break
        }
        let translated = elem.getIn(['props', 'translation', FTLang], Map())
        translated.map((toVal, key) => {
          const [tabs, tabID, info, propKey, elemKey] = String(key).split('##')
          _.each(LAYOUT_MODE, function (layoutMode) {
            if (elem.hasIn(['props', layoutMode, 'tabs'])) {
              elem.getIn(['props', layoutMode, 'tabs'], List()).map((item, index) => {
                if (item.get('id') === tabID) {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', layoutMode, 'tabs', index, info, propKey, elemKey],
                    state.getIn([
                      ...elemRoot,
                      'elements',
                      elemUID,
                      'props',
                      layoutMode,
                      'tabs',
                      index,
                      info,
                      propKey,
                      elemKey,
                    ])
                  )
                  elem = elem.setIn(['props', layoutMode, 'tabs', index, info, propKey, elemKey], toVal)
                }
              })
            }
          })
        })
        state = state.setIn([...elemRoot, 'elements', elemUID], elem)
        break
      }
      case 'Stepper':
      case 'MultiStepper':
      case 'Accordion':
      case 'TwoSideSection':
      case 'CarouselContainer':
      case 'ContinualForm':
      case 'Tab':
        {
          let translated = elem.getIn(['props', 'translation', FTLang], Map())
          translated.map((toVal, key) => {
            const [, id] = String(key).split('##')
            if (elem.getIn(['props', 'source'], 'static') === 'static') {
              _.each(LAYOUT_MODE, function (layoutMode) {
                if (elem.hasIn(['props', layoutMode, 'tabs'])) {
                  elem.getIn(['props', layoutMode, 'tabs'], List()).map((item, index) => {
                    if (item.get('id') === id) {
                      setCache(
                        [...elemRoot, 'elements', elemUID, 'props', layoutMode, 'tabs', index, 'label'],
                        state.getIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, 'tabs', index, 'label'])
                      )
                      elem = elem.setIn(['props', layoutMode, 'tabs', index, 'label'], toVal)
                    }
                  })
                }
              })
            }
          })
          if (['Stepper', 'MultiStepper'].includes(type)) {
            if (translated.get('PrevBtn')) {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', 'PrevBtn'],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', 'PrevBtn'])
              )
              elem = elem.setIn(['props', 'captions', 'PrevBtn'], translated.get('PrevBtn'))
            }
            if (translated.get('NextBtn')) {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', 'NextBtn'],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', 'NextBtn'])
              )
              elem = elem.setIn(['props', 'captions', 'NextBtn'], translated.get('NextBtn'))
            }
            if (translated.get('FinishBtn')) {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', 'FinishBtn'],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', 'FinishBtn'])
              )
              elem = elem.setIn(['props', 'captions', 'FinishBtn'], translated.get('FinishBtn'))
            }
          }
          state = state.setIn([...elemRoot, 'elements', elemUID], elem)
        }
        break
      case 'Widget':
        switch (elem.getIn(['props', 'data', 'Type'])) {
          case 'galleryGrid':
          case 'TestimonialsCarousel':
          case 'galleryCarousel':
          case 'ExtendedGallery': {
            let translated = elem.getIn(['props', 'translation', FTLang], Map())
            translated.map((str, key) => {
              if (['header', 'headerDescr'].includes(key)) {
                _.each(LAYOUT_MODE, (mode) => {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', mode, key],
                    state.getIn([...elemRoot, 'elements', elemUID, 'props', mode, key])
                  )
                  elem = elem.setIn(['props', mode, key], str)
                })
              }
            })
            state = state.setIn([...elemRoot, 'elements', elemUID], elem)
            break
          }
          case 'infoBox': {
            let translated = elem.getIn(['props', 'translation', FTLang], Map())
            translated.map((str, key) => {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'data', 'Props', key],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'data', 'Props', key])
              )
              elem = elem.setIn(['props', 'data', 'Props', key], str)
            })
            state = state.setIn([...elemRoot, 'elements', elemUID], elem)
            break
          }

          case 'list':
          case 'table': {
            let translated = elem.getIn(['props', 'translation', FTLang], Map())
            const propKey = elem.getIn(['props', 'data', 'Type']) === 'list' ? 'columns' : 'mapping'
            translated.map((str, key) => {
              if (['header', 'headerDescr'].includes(key)) {
                _.each(LAYOUT_MODE, (mode) => {
                  setCache(
                    [...elemRoot, 'elements', elemUID, 'props', mode, key],
                    state.getIn([...elemRoot, 'elements', elemUID, 'props', mode, key])
                  )
                  elem = elem.setIn(['props', mode, key], str)
                })
              }
              let [, id] = String(key).split('##')
              let index = elem.getIn(['props', 'data', 'Props', propKey], List()).findIndex((v) => v.get('id') === id)
              if (index !== -1) {
                setCache(
                  [...elemRoot, 'elements', elemUID, 'props', 'data', 'Props', propKey, index, 'label'],
                  state.getIn([...elemRoot, 'elements', elemUID, 'props', 'data', 'Props', propKey, index, 'label'])
                )
                elem = elem.setIn(['props', 'data', 'Props', propKey, index, 'label'], str)
              }
            })

            let langs = {}
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })

            _.each(langs.captions, (val, key) => {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
              )
              elem = elem.setIn(['props', 'captions', key], val)
            })

            state = state.setIn([...elemRoot, 'elements', elemUID], elem)
            break
          }
          case 'TablePricing':
          case 'Scheduler': {
            let translated = elem.getIn(['props', 'translation', FTLang], Map())
            let langs = {}
            translated.map((val, key) => {
              let path = String(key).replace('##', '.')
              langs = _.set(langs, path, val)
            })
            _.each(langs.captions, (val, key) => {
              setCache(
                [...elemRoot, 'elements', elemUID, 'props', 'captions', key],
                state.getIn([...elemRoot, 'elements', elemUID, 'props', 'captions', key])
              )
              elem = elem.setIn(['props', 'captions', key], val)
            })
            state = state.setIn([...elemRoot, 'elements', elemUID], elem)
            break
          }
          case 'ImageChoice': {
            let translated = elem.getIn(['props', 'translation', FTLang], Map())
            translated.map((toVal, key) => {
              let useKey = String(key).includes('##') ? key.split('##') : [key]
              let defVal = elem.getIn(['props', 'lg', ...useKey])
              if (toVal) {
                if (!state.hasIn([...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, ...useKey])) {
                  state = state.setIn(
                    [...elemRoot, 'elements', elemUID, 'props', 'translation', defaultLang, ...useKey],
                    defVal
                  )
                }
                _.each(LAYOUT_MODE, function (layoutMode) {
                  if (elem.getIn(['props', layoutMode]) || layoutMode == 'lg') {
                    setCache(
                      [...elemRoot, 'elements', elemUID, 'props', layoutMode, ...useKey],
                      state.getIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, ...useKey])
                    )
                    state = state.setIn([...elemRoot, 'elements', elemUID, 'props', layoutMode, ...useKey], toVal)
                  }
                })

                //check translation for items outside of Layout modes (currently only suffix and prefix) that have a text property
                defVal = elem.getIn(['props', ...useKey])
                if (defVal?.get && defVal.get('text')) {
                  let translationPath = [
                    ...elemRoot,
                    'elements',
                    elemUID,
                    'props',
                    'translation',
                    defaultLang,
                    ...useKey,
                  ]
                  if (!state.hasIn(translationPath)) {
                    state = state.setIn(translationPath, defVal)
                  }

                  let path = [...elemRoot, 'elements', elemUID, 'props', ...useKey]
                  setCache(path, state.getIn(path))
                  state = state.setIn([...path, 'text'], toVal)
                }
              }
            })
            break
          }
        }
      //     break;
    }
  }

  pages.map((page, pageID) => {
    if (openPageID && openPageID != pageID) {
      return false
    }
    let elements = page.getIn(['Props', 'elements'], Map())
    let pageUID = getPageUID(pageID, state.getIn(['project', 'Pages'], List()))
    elements.map(processElem(pageID, pageUID))
  })

  {
    let elements = state.getIn(['project', 'Settings', 'elements'], Map())
    elements.map(processElem('project', 'project'))
  }

  state = state.set('translationCache', cache)

  if (dispatch) {
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })

    dispatch(refreshValidationMessages())

    if (
      state.getIn(['project', 'ProjectType']) === SURVEY_TYPE ||
      state.getIn(['project', 'ProjectType']) === SURVEY_EMAIL_TYPE
    ) {
      dispatch({
        type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
        payload: {
          data: {},
        },
      })
    }
  }

  return state
}
